// extracted by mini-css-extract-plugin
export default {"root":"zQQTI","title":"yK4Lq","sticker":"Ekl_6","selected":"l_YsP","iconWrapper":"lNOO9","icon":"SHIeX","content":"ehHEV","label":"XB4DU","value":"YGY8x"};